import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=50c80fce"
import script from "./NumberInput.ts?vue&type=script&lang=ts&external"
export * from "./NumberInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports